<template>
  <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
  <div :class="componentClassName">
    <a-page-heading>アウトバウンド</a-page-heading>
    <m-section>
      <m-action-card title="" icon="">
        <div class="t-outbound-call__main">
          <form v-if="isFinishCallList" class="t-outbound-call__end-call-page">
            <div class="t-outbound-call__end-list-message">
              <h2>すべての架電が完了しました</h2>
            </div>
            <div class="t-outbound-call__end-list-button">
              <a-button
                id="returnList"
                label="リストに戻る"
                color="grey"
                variant="round"
                size="small"
                @click="handleReturnList"
              >
              </a-button>
            </div>
          </form>
          <div v-if="!isFinishCallList && outboundCallListData.id" class="t-outbound-call__media-setting">
            <!--マイクロ・スピーカーStart-->
            <a-calling-action-button
              v-if="!isEnded"
              icon="gear"
              popup-position="bottom"
              :activated="isSettingActionOpened"
              :popup="isSettingActionOpened"
              :handle-action-button-click="handleSettingActionButtonClick"
            >
              <template #popup>
                <div class="m-action-card__header-title">
                  <a-heading id="audioTitle" :heading="audioTitle" tag="h4" size="small" />
                  <div class="m-action-card__header-title-help">
                    <a-button :inline="true" @click="helpModalVisible = true">
                      <a-icon icon="help-outline" color="black" />
                    </a-button>
                  </div>
                </div>
                <m-form-input label="マイク">
                  <a-select-field
                    v-model="currentMicrophone"
                    :options="microphoneListOptions"
                    placeholder="選択してください"
                    @change="handleMicrophoneSelectionChange"
                  />
                </m-form-input>
                <m-form-input label="スピーカー">
                  <a-select-field
                    v-model="currentSpeaker"
                    :options="speakerListOptions"
                    placeholder="選択してください"
                    @change="handleSpeakerSelectionChange"
                  />
                </m-form-input>
              </template>
            </a-calling-action-button>
            <!--マイクロ・スピーカーEnd-->
          </div>
          <div v-if="!isFinishCallList && outboundCallListData.id" class="t-outbound-call__controls">
            <div class="t-outbound-call__caller-info">
              <a-calling-customer-info
                v-if="customerInfo"
                :title="customerInfo.title"
                :phone-number="displayName"
                :subtitle="customerInfo.subtitle"
                :outbound="true"
                :fulltitle="displayTooltipName"
              />
              <div class="t-outbound-call__current-progress">
                {{ customerInfo.order }}件目/{{ outboundCallListData.progressRepeatInfo }}件中
              </div>
              <div class="t-outbound-call__current-progress">
                {{ outboundCallListData.repeatCount }}回目/{{ outboundCallListData.repeatLimit }}回中
              </div>
              <div class="t-outbound-call__caller-info-status">
                <a-calling-status v-if="!isEnded && isCalling" :status="callingStatus" />
                <a-calling-status v-if="isEnded" :status="'ended'" />
              </div>

              <!-- <div class="t-outbound-call__response-status">
                <a-calling-response-status :status-list="responseStatusList" />
              </div> -->

              <div v-if="telNumberInfo" class="t-outbound-call__response-status">
                <a-calling-response-status v-if="telNumberInfoList.length" :status-list="telNumberInfoList" />
              </div>
            </div>
            <div class="t-outbound-call__actions">
              <div v-if="!isCalling && !isEnded && !isConnectingCall" class="t-outbound-call__progress-action-button">
                <m-calling-action-button-list>
                  <a-calling-action-button
                    id="btnReturnList"
                    label="リストに戻る"
                    color="primary"
                    variant="round"
                    :activated="isReturnlistOpened"
                    :popup="isReturnlistOpened"
                    :handle-action-button-click="handleCallingReturnToList"
                  >
                  </a-calling-action-button>
                  <a-calling-action-button
                    id="btnRound"
                    label="次の架電"
                    color="primary"
                    variant="round"
                    :handle-action-button-click="handleNextPhoneButtonClick"
                  >
                  </a-calling-action-button>
                </m-calling-action-button-list>
              </div>
              <div
                v-if="isEnded"
                class="t-outbound-call__progress-action-button t-outbound-call__progress-back-action-button"
              >
                <m-calling-action-button-list>
                  <a-calling-action-button
                    id="outbound_call_return_list_button"
                    label="保存してリストに戻る"
                    color="primary"
                    variant="round"
                    :tooltip="isNotCallStatus"
                    data-tooltip="発信結果を選択してください"
                    :disabled="isNotCallStatus"
                    :activated="isReturnlistOpenedCallingState"
                    :handle-action-button-click="handleReturnListCallingState"
                  >
                  </a-calling-action-button>
                  <a-calling-action-button
                    id="outbound_call_next_button"
                    label="保存して次の架電"
                    color="primary"
                    variant="round"
                    :tooltip="isNotCallStatus"
                    data-tooltip="発信結果を選択してください"
                    :disabled="isNotCallStatus"
                    :handle-action-button-click="handleNextPhoneCallingState"
                  >
                  </a-calling-action-button>
                </m-calling-action-button-list>
              </div>
              <div v-if="!isEnded && isCalling" class="t-outbound-call__actions-list">
                <m-calling-action-button-list>
                  <a-calling-action-button
                    label="保留"
                    icon="phone-call-onhold"
                    :activated="isHolding"
                    :handle-action-button-click="handleHoldActionButtonClick"
                    :disabled="shouldDisableHoldingButton"
                    :is-visible="!isHoldCountExceeded && !isReachHoldCountMax"
                  />
                  <a-calling-action-button
                    v-if="!isEnded && isCalling"
                    label="ダイヤル"
                    icon="numpad"
                    :activated="isNumpadActionOpened"
                    :popup="isNumpadActionOpened"
                    :handle-action-button-click="handleNumpadActionButtonClick"
                    :disabled="shouldDisableNumpadButton"
                  >
                    <template #popup>
                      <m-numpad class="t-outbound-call__numpad" @click="handleNumpadClick" />
                    </template>
                  </a-calling-action-button>
                </m-calling-action-button-list>
              </div>

              <div v-if="!isEnded && sfAvailable" class="t-outbound-call__sfinfo">
                <div class="t-outbound-call__sfinfo__title">Salesforce取引先責任者</div>
                <div class="t-outbound-call__sfinfo__item">
                  <ul>
                    <li
                      v-if="customerInfo.sfCurrentInfo.sfContactInfo.length > 0"
                      class="t-outbound-call__sfinfo__name"
                    >
                      {{ customerInfo.sfCurrentInfo.sfContactInfo[0].Name }}
                    </li>
                    <li
                      v-if="
                        !customerInfo.sfCurrentInfo.sfContactInfo ||
                        customerInfo.sfCurrentInfo.sfContactInfo.length == 0
                      "
                      class="t-outbound-call__sfinfo__name"
                    >
                      {{ sfContactUnregistered }}
                    </li>
                  </ul>
                </div>
                <div class="t-outbound-call__sfinfo__description">
                  <a-text v-if="sfTable === 'Case'">過去のSalesforceケース</a-text>
                  <a-text v-if="sfTable === 'Task'">過去のSalesforce活動履歴</a-text>
                  <m-data-table
                    :empty-text="'履歴はありません。'"
                    :fit="true"
                    :data="customerInfo.sfCurrentInfo.sfCases"
                  >
                    <a-data-table-column label="件名" align="left">
                      <template #default="scope">
                        <a-button :href="scope.row.sfRecordUrl" :target="'_blank'" type="text" color="primary">
                          {{ scope.row.sfSubject }}
                        </a-button>
                      </template>
                    </a-data-table-column>
                    <a-data-table-column prop="CreatedDateStr" label="日時" align="left" />
                    <a-data-table-column prop="sfOperator" label="対応オペレータ名" align="left" />
                  </m-data-table>
                </div>
              </div>
              <div v-if="!isEnded && !isCalling && !isConnectingCall" class="t-outbound-call__outgoing-call-button">
                <a-button
                  id="call-button"
                  color="primary"
                  icon-color="white"
                  variant="round"
                  label="発信"
                  icon="phone-outgoing-call"
                  :disabled="isBusy || isStartCalling"
                  @click="handleCallButtonClick"
                  >発信
                  <loading :active="isStartCalling" :is-full-page="false" :height="30" :width="30"></loading>
                </a-button>
              </div>
              <div
                v-if="!isEnded && !isCalling && isConnectingCall"
                class="t-outbound-call__end-button t-outbound-call__end-cancel-button"
              >
                <a-calling-action-button
                  id="cancel-outgoing-button"
                  icon="phone-hang-up-call"
                  variant="round"
                  label="キャンセル"
                  @click="handleHangupClick"
                >
                </a-calling-action-button>
              </div>
              <div v-if="!isEnded && isCalling && !isConnectingCall" class="t-outbound-call__end-button">
                <a-calling-action-button
                  id="endCallButton"
                  variant="round"
                  label="通話終了"
                  icon="phone-hang-up-call"
                  :activated="isEndCallActionOpened"
                  :popup="isEndCallActionOpened"
                  :handle-action-button-click="handleEndCallButtonClick"
                >
                  <template #popup>
                    <a-button
                      id="endCallButton2"
                      variant="round"
                      color="primary-red"
                      label="通話を終了する"
                      @click="handleEndCall"
                    />
                  </template>
                </a-calling-action-button>
              </div>
            </div>
          </div>
          <div v-if="!isFinishCallList && outboundCallListData.id" class="t-outbound-call__data">
            <form class="t-outbound-call__form" @submit.prevent="handleFormSubmit">
              <div class="t-outbound-call__memo">
                <div class="m-form-input">
                  <label class="m-form-input__label">メモ （残り文字数: {{ countWordsMemo }}文字）</label>
                  <div class="m-form-input__content">
                    <div class="a-text-field a-text-field--text">
                      <textarea
                        v-model="customerInfo.memo"
                        :disabled="
                          (!isEnded && !isCalling) || (isEnded && !checkIsValidCallSid(customerInfo.currentCallSid))
                        "
                        class="a-text-field__input"
                        :maxlength="maxMemoLength"
                        placeholder="メモは500字以内で入力してください"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="!isCalling && !isEnded">
                  <m-form-input label="前回発信結果">
                    <p>{{ displayStatus }}</p>
                  </m-form-input>
                </div>
                <div v-if="isCalling || isEnded">
                  <m-form-input label="発信結果">
                    <a-select-field
                      :id="'callStatusSelect'"
                      v-model="currentCallStatus"
                      :name="'callStatusSelectName'"
                      :options="callStatus"
                      :classes="getSelectColor"
                    />
                  </m-form-input>
                </div>
              </div>
            </form>
          </div>
        </div>
      </m-action-card>
    </m-section>

    <teleport to="body">
      <o-modal
        id="outboundCall_infoModal"
        v-model:visible="infoModalVisible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="$zindex-modal"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ infoModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="infoModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="modal-ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>

      <o-modal
        id="outboundCall_areLockedModal"
        v-model:visible="notifyAllNumberAreLockedModalVisible"
        class="o-modal-notify-all-number-locked-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="$zindex-modal"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title> Info </template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="notifyMessage"> </span>
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="modal-ok" variant="block" color="primary" label="OK" size="small" @click="handleReturnList" />
        </template>
      </o-modal>

      <o-modal
        id="outboundCall_cancelCallErrorModal"
        v-model:visible="cancelCallErrorModalVisible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="$zindex-modal"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ cancelCallErrorModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="cancelCallErrorModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="modal-ok"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseCancelCallErrorModalTitle"
          />
        </template>
      </o-modal>
    </teleport>

    <!-- アウトバウンド発信する際に着信中の場合、確認モーダル表示される -->
    <teleport to="body">
      <o-modal
        id="outboundCall_incomingCallModal"
        v-model:visible="rejectIncomingCallModal.visible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="$zindex-modal"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ infoModalTitle }}</template>
        <a-text>
          <span>{{ rejectIncomingCallModal.msg }}</span>
        </a-text>
        <template #footer>
          <a-button
            id="reject-incoming-call-modal-ok"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleRejectIncomingCallModalOK"
          />
          <a-button
            id="reject-incoming-call-modal-cancel"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            @click="rejectIncomingCallModal = {}"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="outboundCall_nextPhoneOpened"
        v-model:visible="isNextPhoneOpened"
        class="o-modal-is-next-phone-opened"
        footer-variant="confirmation"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-header="false"
      >
        <div class="a-calling-action-button__popup__body" align="center">
          <span class="a-calling-action-button__popup__body__next-phone"
            >この番号には発信しません<br />次の架電先を取得します</span
          >
        </div>
        <template #footer>
          <a-button id="nextPhone" variant="block" color="primary" label="OK" size="small" @click="handleNextPhone" />
          <a-button
            id="nextPhoneCancel"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            @click="handleNextPhoneButtonClick"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="outboundCall_helpModal"
        v-model:visible="helpModalVisible"
        class="o-modal-audio-setting-hint"
        footer-variant="confirmation"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <template #title>マイク・スピーカーの既定/通信とは</template>
        <a-text v-html="currentAudioHintMessage"> </a-text>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import Loading from 'vue-loading-overlay';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { showMsgBoxMixin } from '@/common/showMsgBox.js';

import { POINT } from '@/libs/constants';
import { utils } from '@/common/utils.js';
import { statusConst } from '@/libs/constants';
import { PERMISSIONS_FRONTEND, DEFAULT_DEVICE } from '@/libs/constants';

import { Device } from '@twilio/voice-sdk';
import { markRaw } from 'vue';
import { chkTrialCompanyID } from '@/libs/utils';

export default {
  name: 't-outbound-call',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
    Loading,
  },
  mixins: [customRequest, customValidate, showMsgBoxMixin, utils],

  // Vueの機能：他の画面へ遷移する前に実装
  beforeRouteLeave(to, from, next) {
    this.handleUnlock();
    next();
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    outboundProps: {
      type: Object,
      default: null,
    },
    sfCurrentInfo: {
      type: Object,
      default: null,
    },
    userID: {
      type: String,
      default: '',
      required: true,
    },
    speakerDevices: {
      type: Array,
      default: new Array(0),
    },
    inputDevices: {
      type: Array,
      default: new Array(0),
    },
  },
  data() {
    return {
      //架電先情報
      customerInfo: {
        key: '', //架電のID
        title: '', //架電名称
        phoneNumber: '', //架電番号
        subtitle: '', //
        rawPhoneNumber: '', //+81形の架電番号
        status: '', //前回の架電結果のステータス
        currentCallSid: '', //今回の通話のCallSid
        priorCallSid: '', //前回の通話のCallSid
        memoCallSid: '',
        memo: '', //メモ
        sfCurrentInfo: {
          sfCases: [], //
          sfContactInfo: [],
        },
        createdCaseId: '',
        dialCount: 0,
        order: 0,
      },

      //表示している架電のID
      currentIndex: 0,

      //アウトバウンド一覧詳細情報
      outboundCallListData: {
        id: '',
        listName: '',
        outboundCallList: {},
        phone: '',
        phoneName: '',
        progressRepeatInfo: 0,
        progressInfo: 0,
        repeatLimit: 1,
        repeatCount: 1,
        startFlag: false,
        timestamp: '',
        updateDate: '',
        processCallIndex: '',
        total: 0,
        allowCall: true,
      },

      //表示用の架電名称
      displayName: '',

      //ツールチップ表示用の架電名称
      displayTooltipName: '',

      //発信元の電話番号、電話名称
      telNumberInfo: {
        telNumber: '',
        numberName: '',
      },
      //info modal
      infoModalTitle: '',
      infoModalContent: '',
      infoModalVisible: false,

      //ロック通話　modal
      notifyAllNumberLockedModalContent: '',
      notifyAllNumberAreLockedModalVisible: false,

      //発信キャンセルモーダル
      cancelCallErrorModalVisible: false,
      cancelCallErrorModalTitle: messageContent.errorModalTitle,
      cancelCallErrorModalContent: messageContent.cancelOutboundCallError,

      //通話中のステータス
      isCalling: false,

      //発信中のステータス
      isConnectingCall: false,
      //popup
      //リストに戻るポップアップ
      isReturnlistOpened: false,
      //次の架電ポップアップ
      isNextPhoneOpened: false,
      //保存してリストに戻るポップアップ
      isReturnlistOpenedCallingState: false,
      //保存して次の架電ポップアップ
      isNextPhoneOpenedCallingState: false,
      //通話終了
      isEndCallActionOpened: false,
      //スピーカーとマイクロフォンポップアップ
      isSettingActionOpened: false,
      //Numpadポップアップ
      isNumpadActionOpened: false,

      //架電ステータス
      callStatus: [
        { value: 'completed', label: '完了' },
        { value: 'repeat', label: '再架電' },
        { value: 'absent', label: '不在' },
        { value: 'onTalking', label: '話中' },
        { value: 'phoneAnswer', label: '留守電' },
        { value: 'outOfService', label: '圏外' },
        { value: 'other', label: 'その他' },
      ],

      //設定している発信結果
      currentCallStatus: '',

      //発信結果未設定フラグ
      isNotCallStatus: true,

      //通話完了ステータス
      isEnded: false,

      //架電番号リストが完了
      isFinishCallList: false,

      //Twilio設定
      device: null,

      //スピーカーとマイクロフォン
      microphoneListOptions: [{ label: '選択してください', value: localStorage.getItem('microphoneId') }],
      speakerListOptions: [{ label: '選択してください', value: localStorage.getItem('speakerId') }],
      currentMicrophone: '',
      currentSpeaker: '',

      //発信フラグ
      directionFlg: 'outbound-dial',

      //saleforce
      sfAvailable: false,
      sfContactAvailable: false,
      sfTable: false,
      sfContactUnregistered: '<取引先責任者未登録>',

      //保留中ステータス
      isHolding: false,
      //最大の保留回数
      isHoldCountExceeded: false,
      //保留中通話取得
      queueCheckInterval: null,
      //スピンナー
      isLoading: false,
      isStartCalling: false,
      //memo
      maxMemoLength: 500,

      totalComplete: 0,

      // アウトバウンド発信する際に着信中の場合、確認モーダル表示される
      rejectIncomingCallModal: {},

      notifyMessage: '',

      COTOHACallCenterManualURL: '',

      helpModalVisible: false,

      audioTitle: 'マイク・スピーカー設定',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-outbound-call');
      return `${baseClassName} ${this.class}`.trim();
    },
    authInfo() {
      return this.$store.state.user.authInfo;
    },
    currentPhoneNumber() {
      return this.$store.state.user.phoneNumber;
    },
    currentCompanyID() {
      return this.$store.state.user.companyID;
    },
    isAllowAccess() {
      return ['supervisor', 'manager'].includes(this.authInfo);
    },
    telNumberInfoList() {
      const ret = [];
      if (!this.telNumberInfo) return ret;
      if (this.telNumberInfo.numberName) {
        ret.push({ label: '番号名称', value: this.collapseText(this.telNumberInfo.numberName, 10) });
      }
      if (this.telNumberInfo.telNumber) {
        ret.push({ label: '自番号', value: this.telNumberInfo.telNumber });
      }
      return ret;
    },
    formatSelectedCurrentNumber() {
      return this.formatSysTemCallNumber(this.$store.state.user.phoneNumber);
    },
    clientName() {
      return this.$store.state.user.clientName;
    },
    agentName() {
      return this.$store.state.user.username;
    },
    displayStatus() {
      return this.handleDisplayName();
    },
    countWordsMemo() {
      return this.caculateRemainMemoCount();
    },
    isBusy() {
      if (!this.outboundProps) return false;
      return this.outboundProps.isCalling || this.outboundProps.isTalking;
    },
    currentAudioHintMessage() {
      return messageContent.audioHintMessage(this.COTOHACallCenterManualURL);
    },
    getSelectColor() {
      if (this.currentCallStatus === '') {
        return 'a-select-field__noselect';
      } else {
        return '';
      }
    },
  },
  watch: {
    inputDevices(val) {
      this.loadMicrophoneList(val);
    },
    speakerDevices(val) {
      this.loadSpeakerList(val);
    },
    currentCallStatus(val) {
      if (val === '') {
        this.isNotCallStatus = true;
      } else {
        this.isNotCallStatus = false;
      }
    },
  },
  async created() {
    if (PERMISSIONS_FRONTEND['OutboundCall']) {
      if (!PERMISSIONS_FRONTEND['OutboundCall'][this.authInfo]) {
        this.$router.push({ path: '/permission-denied' });
        return;
      }
    }
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.$router.push({
        path: '/permission-denied',
        query: { type: 'trial', page: 'outbound' },
      });
    }

    this.selectedCompanyID = this.$route.query.companyID;
    const callListID = this.$route.query.id;
    if (callListID) {
      //beforeunload：ブラウザークローズする前に実装
      window.addEventListener('beforeunload', this.handleUnlock);
      this.handleGetCallData({ id: callListID }, false);
    } else {
      this.$router.push({ path: '/notfound' });
      return;
    }
    this.loadMicrophoneList(this.inputDevices);
    this.loadSpeakerList(this.speakerDevices);
    await this.handlerFetchSettingOther();
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(stream => {
        if (this.microphoneListOptions.length === 1 && !this.microphoneListOptions[0]['value']) {
          this.microphoneListOptions = [
            { label: '選択してください', value: localStorage.getItem('microphoneId') || DEFAULT_DEVICE },
          ];
        }
        if (this.speakerListOptions.length === 1 && !this.speakerListOptions[0]['value']) {
          this.speakerListOptions = [
            { label: '選択してください', value: localStorage.getItem('speakerId') || DEFAULT_DEVICE },
          ];
        }
        stream.getTracks()[0].stop();
      })
      .catch(err => {
        console.log(err);
        this.showInfoModal(messageContent.chromeMicroPermissionError);
      });
  },
  mounted() {
    this.handleGetSettingSf();
    this.handleGetSfPopup();
    this.handleRequestToken();
    const ringingBackToneURL = `/public/assets/RingBackTone.mp3`;
    const audio = new Audio(ringingBackToneURL);
    audio.loop = true;
    this.ringingBackTone = audio;
    const self = this;
    audio.onerror = function () {
      //Ringbacktone not found
      self.ringingBackTone = null;
    };
  },

  //他の画面でこの関数を実装しないように、遷移する前にbeforeunload削除
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.handleUnlock);
  },
  methods: {
    //他画面に遷移とか、ブラウザークローズとかの時に実装
    handleUnlock(event) {
      if (this.outboundCallListData.id && this.customerInfo.key) {
        console.info('handleUnlock start');
        // 通話終了時にリロードするとダイアログ表示
        if (this.isEnded) {
          event.preventDefault();
          event.returnValue = '';
        }

        if (event) event.preventDefault();
        //(event || window.event).returnValue = null;
        const updateData = {
          id: this.outboundCallListData.id,
          key: this.customerInfo.key.toString(),
          nameStatus: '', //ロック解除
        };
        this.handleUpdateCallStatus(updateData);
      }
    },
    handleRequestToken() {
      const self = this;
      this.postRequest('/token')
        .then(function (e) {
          if (e.status === 'success') {
            if (!self.device) {
              const options = {
                codecPreferences: ['opus', 'pcmu'],
                fakeLocalDTMF: true,
                enableRingingState: true,
                edge: 'tokyo',
                debug: false,
                closeProtection: true,
              };
              self.device = markRaw(new Device(e.data.token, options));
              self.handleInitialDevice();

              //Device must be registered in order to receive incoming calls
              self.device.register();

              //Sync
              //self.handleSyncDocument(e.data.token);
            } else {
              //TokenがExipredなら、更新する
              self.device.updateToken(e.data.token);
            }

            // Update agent status
            //self.updateOnlineStatus(e.data.agentStatus);
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireMakeCall('通話設定'));
        });
    },
    handleInitialDevice() {
      const self = this;

      this.device.on('error', function (error) {
        //console.log('Twilio.Device Error: ' + error.message);
        if (error.code === 20104) {
          //Token expire
          self.handleRequestToken();
        } else {
          self.isLoading = false;
        }
      });

      if (this.device.audio.isOutputSelectionSupported) {
        //console.log('audio output support');
      }
    },
    handleRejectIncomingCallModalOK() {
      this.handleCall(this.rejectIncomingCallModal.to, this.rejectIncomingCallModal.from, true);
      this.rejectIncomingCallModal = {};
    },
    async handleCall(to, from, forceRejectIncomingCall = false) {
      if (this.isBusy) {
        this.showErrorModal(messageContent.requireMakeCall('発信中や通話中'));
        return;
      }

      if (this.outboundProps.hasNewCall && forceRejectIncomingCall) {
        this.outboundProps.rejectCall(this.outboundProps.conn);
      }

      if (this.outboundProps.hasNewCall && !forceRejectIncomingCall) {
        this.rejectIncomingCallModal = { visible: true, to, from, msg: messageContent.outboundRejectIncomingCall };
        return;
      }

      if (this.customerInfo.dialCount > 3) {
        this.showErrorModal(messageContent.notifyMaxCall);
      }

      if (!this.device || this.device.state === Device.State.Unregistered) {
        this.showErrorModal(messageContent.notifyTwilioDeviceNotReadyWarning);
        return;
      }
      if (to && chkTrialCompanyID(this.companyID)) {
        this.showErrorModal(messageContent.titleTextTrial());
        return;
      }
      this.isbuttonCall = 'on';
      //スピーカーとマイクロフォン設定
      const handleAudioResult = await this.handleAudio();
      if (!handleAudioResult) return;

      // Contract status check
      let constractStatus, trialStatus;
      await this.postRequest('/contract/status-check')
        .then(res => {
          if (res.status === 'success') {
            trialStatus = res.data.trialStatus;
            constractStatus = res.data.contractStatus;
          } else {
            this.showErrorModal(messageContent.requireTry('契約情報確認'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('契約情報確認'));
        });
      //契約情報確認中にエラーが発生しました。
      if (!constractStatus && !trialStatus) return;
      //If contract is closing, stop the call
      if (constractStatus === 'close') {
        this.showErrorModal(messageContent.requireMakeCall('解約済'));
        return;
      }
      //移行期間中の場合通話できない
      if (this.isTrial && trialStatus === 'transiting') {
        this.showErrorModal(messageContent.requireMakeCall('移行期間中'));
        return;
      }

      const params = {
        //テキストに入力された番号がToへ
        To: to.currentPhoneNumber,
        From: this.formatSysTemCallNumber(from),
        CallerNumber: this.formatSysTemCallNumber(from),
        ClientName: this.clientName,
        companyID: this.companyID,
        userID: this.userID,
        contactName: to.title,
      };
      //this.isConnectingCall = true;
      if (this.device) {
        //外線の場合はデフォルトで050発信をできるようにする,050を+81に置換
        const top = params.To.slice(0, 1);
        if (top === '0') {
          params.To = '+81' + params.To.slice(1);
        }

        const outgoingConnection = await this.device.connect({ params });
        //発信中画面
        this.isStartCalling = true;

        await this.delay(1000);
        this.isStartCalling = false;
        this.isConnectingCall = true;
        const self = this;

        let playRingBackTone = null;
        outgoingConnection.on('ringing', function (hasEarlyMedia) {
          if (!hasEarlyMedia) {
            //Wait 2sec for ringbacktone;
            playRingBackTone = setTimeout(() => {
              if (self.ringingBackTone) self.ringingBackTone.play();
            }, 2000);
          } else {
            if (playRingBackTone) clearTimeout(playRingBackTone);
            if (self.ringingBackTone) self.ringingBackTone.pause();
          }
          self.updateAgentCallingStatus(true);
        });

        //通話開始イベント
        outgoingConnection.on('accept', function (conn) {
          self.updateAgentCallingStatus(true);
          if (playRingBackTone) clearTimeout(playRingBackTone);
          if (self.ringingBackTone) self.ringingBackTone.pause();
          self.isConnectingCall = false;
          self.isCalling = true;
          self.customerInfo.currentCallSid = conn.parameters.CallSid;
          self.handleAcceptIncomingCall(conn);
        });

        //通話終了イベント
        outgoingConnection.on('disconnect', async function (conn) {
          if (playRingBackTone) clearTimeout(playRingBackTone);
          if (self.ringingBackTone) self.ringingBackTone.pause();
          //self.isLoading = true;
          //発信終了イベントとDeviceの通話終了イベントが重複になっているので、
          //通話開始する前場合、終了の場合、こちらでステータス更新する、
          //通話開始した後場合、終了の場合、Device.on('disconnect')イベントでステータス更新する
          //Acceptしない場合、currentCallSid=null、発信電話番号へ通話できない、
          const handleDisconnectCall = async function () {
            if (!self.customerInfo.currentCallSid) {
              self.handleUpdateCallSid(conn, false);
              //CallSidがCAxx形ではなく、TJSxxの形の場合、通話できませんのでメモを保存しない
              if (!conn.parameters.CallSid || !self.checkIsValidCallSid(conn.parameters.CallSid)) {
                self.showErrorModal(messageContent.notifyCannotSaveMemo);
              }

              self.customerInfo.currentCallSid = conn.parameters.CallSid;
              if (self.sfAvailable === true) {
                const createSfResult = await self.handleCreateSf();
                self.customerInfo.createdCaseId = createSfResult;
              }
            }
            self.handleDisconnectCall();
          };
          if (!Object.prototype.hasOwnProperty.call(conn.parameters, 'CallSid')) {
            //Twilioへまだ接続の場合
            await self.device.disconnectAll();
            self.isLoading = false;
            self.isConnectingCall = false;
            self.isCalling = false;
            //#5713：リングバックトーンが聞こえず、相手にも着信しない。オペレータがキャンセルしない限り、ボタンは発信中の表示のまま。
            self.showCancelCallErrorModal();
          } else if (!self.checkIsValidCallSid(conn.parameters.CallSid)) {
            //Twilioへまだ接続できたが、CallSidがまだ取得できない、取得できるまで待つ
            self.isLoading = true;
            let count = 0;

            //#5714:発信日時と対応オペレータ名が空欄で出力される。
            //CallSidを取得のは時間がかかり、取得まで繰り返す
            const checkCallSidInterval = setInterval(
              conn => {
                count += 500;
                if (self.checkIsValidCallSid(conn.parameters.CallSid)) {
                  clearInterval(checkCallSidInterval);
                  self.device.disconnectAll();
                  handleDisconnectCall();
                  return;
                }

                if (count >= 5000) {
                  self.device.disconnectAll();

                  //#5713:リングバックトーンが聞こえず、相手にも着信しない
                  //コールキャセルすると、時々Twilio Deviceが動けない場合もあって、再設定する
                  // self.device = null;
                  // self.handleRequestToken();
                  self.isLoading = false;
                  clearInterval(checkCallSidInterval);
                  self.isConnectingCall = false;
                  self.isCalling = false;
                  self.showCancelCallErrorModal();
                }
              },
              500,
              conn
            );
          } else {
            handleDisconnectCall();
          }
        });

        //通話エラー、Rejectイベント
        outgoingConnection.on('error', function (error) {
          if (playRingBackTone) clearTimeout(playRingBackTone);
          if (self.ringingBackTone) self.ringingBackTone.pause();
          self.isCalling = false;
          //self.isConnectingCall = false;
          if (error.code === 31005) return; ////reject by client、HANGUP error code
          self.device.disconnectAll();
        });

        const getCallSid = async function (clientName) {
          const result = await self
            .postRequest('/clientUpdate/getinfo', { clientName: clientName })
            .then(data => {
              if (data.status === 'success') return data.data;
              return '';
            })
            .catch(e => {
              return '';
            });
          return result;
        };
        this.handleHangupClick = async () => {
          //#5713: キャンセル時に、CallSidを取得できない（CAxxxではなく、TJSxxx形式になってしまう場合がある問題）の場合、データベースから取得
          if (!outgoingConnection.parameters?.CallSid || !outgoingConnection.parameters.CallSid.includes('CA')) {
            const getCallSidResult = await getCallSid(this.clientName);
            if (getCallSidResult && getCallSidResult.callSid)
              outgoingConnection.parameters.CallSid = getCallSidResult.callSid;
          }
          self.isConnectingCall = false;
          self.isCalling = false;
          outgoingConnection.disconnect();
        };
      }
    },
    handleGetCallData(data, returnListFlag) {
      return this.postRequest('/outbound/getCallListData', data)
        .then(e => {
          if (e.status === 'success') {
            this.outboundCallListData = e.data;
            if (!returnListFlag) {
              // アウトバウンド一覧画面に戻るときは各種チェックは行わない
              if (!this.outboundCallListData.startFlag) {
                this.showNotifyAllNumberAreLocked(messageContent.notifyStartFlagIsFalse);
              }

              if (!this.outboundCallListData.allowCall) {
                this.showNotifyAllNumberAreLocked(messageContent.notifyPhoneNumberCannotUse);
                return;
              }

              if (this.outboundCallListData.progressInfo >= this.outboundCallListData.total) {
                this.isFinishCallList = true;
                return;
              }

              //繰り返し回数が超えるか、未使用番号がない時
              if (this.outboundCallListData.repeatCount > this.outboundCallListData.repeatLimit) {
                this.isFinishCallList = true;
                return;
              }

              //全てロックされている
              if (!this.outboundCallListData.processCallIndex) {
                this.showNotifyAllNumberAreLocked(messageContent.notifyAllPhoneAreLocked);
                return;
              }
            } else {
              // アウトバウンド一覧画面に戻る場合は架電数や繰り返し回数のチェックのみを行う
              if (!this.outboundCallListData.allowCall) {
                return;
              }

              if (this.outboundCallListData.progressInfo >= this.outboundCallListData.total) {
                return;
              }

              if (this.outboundCallListData.repeatCount > this.outboundCallListData.repeatLimit) {
                return;
              }

              if (!this.outboundCallListData.processCallIndex) {
                return;
              }
            }

            this.outboundCallListData.id = data.id;
            //発信番号情報
            this.telNumberInfo.telNumber = this.outboundCallListData.phone;
            this.telNumberInfo.numberName = this.outboundCallListData.phoneName
              ? this.outboundCallListData.phoneName
              : '未設定';

            this.currentIndex = parseInt(this.outboundCallListData.processCallIndex);
            // this.totalComplete =
            //   Object.keys(this.outboundCallListData.outboundCallList).length -
            //   this.outboundCallListData.progressRepeatInfo;
            this.totalComplete = Object.keys(this.outboundCallListData.outboundCallList).length;

            this.outboundCallListData.outboundCallList[this.outboundCallListData.processCallIndex].key =
              this.outboundCallListData.processCallIndex;

            if (!returnListFlag) {
              // アウトバウンド一覧画面に戻るときは画面遷移に関する処理をしない
              this.handleShowProcessingCall(
                this.outboundCallListData.outboundCallList[this.outboundCallListData.processCallIndex]
              );
            }
          } else if (e.status === 'notExist') {
            this.showNotifyAllNumberAreLocked(messageContent.notifyStartFlagIsFalse);
          } else {
            this.showErrorModal(messageContent.requireTry('架電詳細の情報を取得'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('架電詳細の情報を取得'));
        });
    },
    async handleCallButtonClick() {
      // POINTには発信させない
      if (this.companyID === POINT) {
        return;
      }
      const getCallListDetail = await this.postRequest('/outbound/getCallListData', {
        id: this.outboundCallListData.id,
        nameStatusConfirm: true,
      })
        .then(data => {
          if (data.status === 'success') return data.data;
          return null;
        })
        .catch(() => {
          return null;
        });
      if (!getCallListDetail) {
        this.showErrorModal(messageContent.requireTry('発信'));
        return;
      }

      if (!getCallListDetail.allowCall) {
        this.showErrorModal(messageContent.notifyPhoneNumberCannotUse);
        return;
      }
      const to = {
        currentPhoneNumber: this.customerInfo.phoneNumber,
        title: this.customerInfo.title,
      };
      this.handleCall(to, this.outboundCallListData.phone);
    },
    showInfoModal(content) {
      this.infoModalTitle = messageContent.infoModalTitle;
      this.infoModalVisible = true;
      this.infoModalContent = content;
    },
    showErrorModal(message) {
      this.infoModalVisible = true;
      this.infoModalTitle = messageContent.errorModalTitle;
      this.infoModalContent = message;
    },
    handleCloseModal() {
      this.infoModalVisible = false;
      this.infoModalTitle = '';
      this.infoModalContent = '';
    },
    showNotifyAllNumberAreLocked(message) {
      this.notifyMessage = message;
      this.notifyAllNumberAreLockedModalVisible = true;
    },
    formatSysTemCallNumber(phoneNumber) {
      if (!phoneNumber) return null;
      return '+81' + phoneNumber.slice(1);
    },
    linebreakTitle(inputTitle) {
      // 架電先名称の行長調整（1行20文字）
      const lineStr = inputTitle;
      let resultStr = '';
      let strcount = 0;
      while (lineStr.length - strcount > 20) {
        // console.log('sliceTitle:' + lineStr.length - strcount);
        resultStr += lineStr.substr(strcount, 20);
        resultStr += '\n';
        strcount += 20;
      }
      if (lineStr.length - strcount > 0) {
        // console.log('sliceTitle2:' + lineStr.length - strcount);
        resultStr += lineStr.substr(strcount, lineStr.length - strcount);
      }
      return resultStr;
    },
    sliceTitle(inputTitle) {
      // 架電先名称の表示文字数制限
      return inputTitle.length > 60 ? inputTitle.slice(0, 59) + '…' : inputTitle;
    },
    async handleShowProcessingCall(processingCall) {
      this.customerInfo.phoneNumber = processingCall.phone;
      this.customerInfo.rawPhoneNumber = processingCall.phone;
      this.displayName = processingCall.phone;
      const inputTitle = processingCall.name ? processingCall.name : processingCall.phone;
      this.displayTooltipName = this.linebreakTitle(inputTitle);
      const tmpTitle = this.sliceTitle(inputTitle);
      this.customerInfo.title = this.linebreakTitle(tmpTitle);
      this.customerInfo.status = processingCall.status;
      this.currentCallStatus = processingCall.status;
      this.customerInfo.key = processingCall.key;
      this.customerInfo.priorCallSid = processingCall.callSid;
      this.customerInfo.currentCallSid = '';
      this.customerInfo.createdCaseId = '';
      this.customerInfo.dialCount = processingCall.dialCount;
      this.customerInfo.order = processingCall.order;

      this.isEnded = false;
      this.isCalling = false;
      this.isConnectingCall = false;

      if (this.customerInfo.priorCallSid) {
        const memo = await this.handleGetMemo(this.customerInfo.priorCallSid);
        this.customerInfo.memo = memo ? memo : '';
      } else {
        this.customerInfo.memo = '';
      }

      // POINTはSF処理をしない
      if (this.companyID !== POINT) {
        this.handleGetSfHistory();
        this.handleGetSfContactInfo();
      }
    },
    handleEndCallButtonClick() {
      this.isEndCallActionOpened = !this.isEndCallActionOpened;
    },

    handleAcceptIncomingCall: async function (call) {
      this.handleUpdateCallSid(call, true);
      this.isCalling = true;
      this.isLoading = false;
      this.handleSettingCurentCallInfo(call);

      // Salesforce連携がONであればケース作成
      if (this.sfAvailable === true) {
        const createSfResult = await this.handleCreateSf();
        this.customerInfo.createdCaseId = createSfResult;
        if (createSfResult) {
          // 通話録音URLの追加
          let pageUrlDomain = '';
          const pageUrlArr = window.location.href ? window.location.href.split('/') : [];
          if (pageUrlArr.length > 0) {
            pageUrlDomain = pageUrlArr[0] + '//' + pageUrlArr[2];
          } else {
            pageUrlDomain = '';
          }
          await this.postRequest('/callLogClient/updateSfCase', {
            CallSid: this.customerInfo.currentCallSid,
            createdCaseId: createSfResult,
            Memo: '',
            isExtensionCallOutbound: false,
            pageUrl: pageUrlDomain,
          }).catch(err => {
            console.error(err);
          });
        }
      }
    },
    handleUpdateCallSid(call, callingStatus) {
      return this.postRequest('/callSidUpdate', {
        clientName: this.clientName,
        companyID: this.companyID,
        userID: this.userID,
        callSid: call.parameters.CallSid,
        extTo: call.parameters.To,
        partnerClient: call.customParameters.get('CustomerRawPhoneNumber'),
        type: call.customParameters.get('Type'),
        fromClient: call.customParameters.get('fromClient'),
        from: call.parameters.From,
        heldClient: call.customParameters.get('heldClient'),
        callingStatus: callingStatus, //通話中の時、trueになる
        direction: 'outbound-dial',
      });
    },
    handleEndCall(call) {
      if (this.customerInfo.status === 'onhold') {
        this.handleDisconectHoldCall();
      } else {
        this.device.disconnectAll();
        //this.setCallEnd();
      }
    },
    handleDisconnectCall() {
      this.isLoading = false;
      if (this.customerInfo.status === 'onhold') {
        this.customerInfo.status = 'active';
      } else {
        this.setCallEnd();
      }
    },
    handleSettingCurentCallInfo: function (conn) {
      this.callingStatus = 'active';
      if (typeof conn.customParameters.get('isReachHoldCountLimit') !== 'undefined') {
        this.isHoldCountExceeded = conn.customParameters.get('isReachHoldCountLimit') === 'true';
      }
      if (this.limitCountData) {
        this.isHoldCountExceeded = self.limitCountData.isReachHoldCountLimit;
        this.limitCountData = null;
      }
      this.handleNumpadClick = function (digit) {
        return conn.sendDigits(digit);
      };
    },
    handleDisconectHoldCall() {
      const callsid = this.customerInfo.currentCallSid;
      const self = this;
      this.postRequest('/hold/disconnectcall', {
        callSid: callsid,
        directionFlg: this.directionFlg,
        clientName: this.clientName,
      })
        .then(e => {
          self.setCallEnd();
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('切断'));
        });
    },
    async setCallEnd() {
      this.isLoading = false;
      this.customerInfo.status = 'ended';
      this.isEnded = true;
      this.isCalling = false;
      this.isEndCallActionOpened = false;
      await this.device.audio.unsetInputDevice();

      // メモ保存するまでは内線着信させないようにcallingStatusを一時的にTrue
      this.updateAgentCallingStatus(true);
    },
    handleNumpadActionButtonClick() {
      this.isNumpadActionOpened = !this.isNumpadActionOpened;
    },
    /**
     * ポップアップ関連の関数
     * -------------------------------------------------------------
     */
    handleReturnListButtonClick() {
      this.isReturnlistOpened = !this.isReturnlistOpened;
    },
    handleReturnList() {
      // リロード解除
      if (!this.isCalling) {
        window.removeEventListener('beforeunload', this.handleUnlock);
      }
      window.location.href = '/outbound';
    },
    // 発信前画面のリストに戻る
    handleCallingReturnToList() {
      // リロード解除
      if (!this.isCalling) {
        window.removeEventListener('beforeunload', this.handleUnlock);
      }
      // リストに戻るので、ロックを解除する
      const updateData = {
        id: this.outboundCallListData.id,
        key: this.customerInfo.key.toString(),
        nameStatus: '', //ロック解除
      };
      this.handleUpdateCallStatus(updateData);
      window.location.href = '/outbound';
    },

    //次の架電ボタン
    handleNextPhoneButtonClick() {
      this.isNextPhoneOpened = !this.isNextPhoneOpened;
    },

    //次の架電ボタン
    async handleNextPhone() {
      this.handleNextPhoneButtonClick();

      //使用中架電をもう使用しない場合、ロック解放する
      const updateCallStatusData = {
        id: this.outboundCallListData.id,
        key: this.customerInfo.key.toString(),
        status: '',
        nameStatus: 'completed', //使用済みステータス
      };
      const result = await this.handleUpdateCallStatus(updateCallStatusData);
      if (!result) return this.showErrorModal(messageContent.requireTry('次の架電'));

      //this.isUsed = true;

      const nextCallData = {
        id: this.outboundCallListData.id,
      };
      return await this.handleGetCallData(nextCallData, false);
    },

    //保存してリスト戻るボタン
    handleReturnListCallingStateButtonClick() {
      this.isReturnlistOpenedCallingState = !this.isReturnlistOpenedCallingState;
    },

    //保存してリスト戻るダイアログ
    async handleReturnListCallingState() {
      // callingStatusをfalseにする
      this.updateAgentCallingStatus(false);

      this.handleReturnListCallingStateButtonClick();
      if (!this.currentCallStatus) {
        this.showInfoModal(messageContent.requireChoice('発信結果'));
        return;
      }
      if (this.customerInfo.currentCallSid && this.checkIsValidCallSid(this.customerInfo.currentCallSid)) {
        if (this.hasSpecialCharacterInString(this.customerInfo.memo)) {
          this.showInfoModal(messageContent.hasSpecialCharacter);
          return;
        }
        const updatedCallSid = await this.handleSaveMemo(this.customerInfo.currentCallSid, this.customerInfo.memo);
        if (!updatedCallSid) {
          this.showErrorModal(messageContent.requireTry('メモ保存'));
        }
        this.customerInfo.currentCallSid = updatedCallSid;
      } else {
        //今回のコールはCallSidがない場合、前のCallSidを使用
        this.customerInfo.currentCallSid = this.customerInfo.priorCallSid;
      }

      const updateData = {
        id: this.outboundCallListData.id,
        key: this.customerInfo.key.toString(),
        status: this.currentCallStatus,
        callSid: this.customerInfo.currentCallSid,
        nameStatus: 'completed',
      };
      const result = await this.handleUpdateCallStatus(updateData);
      if (result) {
        //this.isUsed = true;

        // リロード解除
        if (!this.isCalling) {
          window.removeEventListener('beforeunload', this.handleUnlock);
        }

        if (this.customerInfo.order === this.outboundCallListData.progressRepeatInfo) {
          // その繰り返しターンでの最後の件の発信後にリストに戻る場合のみ、コール情報の更新を実施
          const nextCallData = {
            id: this.outboundCallListData.id,
            returnListFlag: true,
          };
          await this.handleGetCallData(nextCallData, true);
        }

        window.location.href = '/outbound';
      } else {
        this.showInfoModal(messageContent.requireTry('発信結果の更新'));
        return;
      }
    },

    //保存して次の架電ボタン
    handleNextPhoneCallingStateButtonClick() {
      this.isNextPhoneOpenedCallingState = !this.isNextPhoneOpenedCallingState;
    },

    //保存して次の架電ダイアログ
    async handleNextPhoneCallingState() {
      // callingStatusをfalseにする
      this.updateAgentCallingStatus(false);

      this.handleNextPhoneCallingStateButtonClick();
      if (!this.currentCallStatus) {
        //発信結果チェック、なければエラー
        this.showInfoModal(messageContent.requireChoice('発信結果'));
        return;
      }
      if (this.customerInfo.currentCallSid && this.checkIsValidCallSid(this.customerInfo.currentCallSid)) {
        if (this.hasSpecialCharacterInString(this.customerInfo.memo)) {
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return;
        }
        //メモをデータベースに保存
        const updatedCallSid = await this.handleSaveMemo(this.customerInfo.currentCallSid, this.customerInfo.memo);
        if (!updatedCallSid) {
          this.showErrorModal(messageContent.requireTry('メモ保存'));
        }
        this.customerInfo.currentCallSid = updatedCallSid;
      } else {
        //今回のコールはCallSidがない場合、前のCallSidを使用
        this.customerInfo.currentCallSid = this.customerInfo.priorCallSid;
      }

      const updateData = {
        id: this.outboundCallListData.id,
        key: this.customerInfo.key.toString(),
        status: this.currentCallStatus, //発信結果ステータス
        callSid: this.customerInfo.currentCallSid, //発信したCallSid
        nameStatus: 'completed', //使用済み
      };

      await this.handleUpdateCallStatus(updateData);
      const nextCallData = {
        id: this.outboundCallListData.id,
      };
      await this.handleGetCallData(nextCallData, false);
    },
    /**
     * スピーカーとマイクロフォン関連の関数
     * -------------------------------------------------------------
     */
    handleSettingActionButtonClick() {
      this.isSettingActionOpened = !this.isSettingActionOpened;
    },
    handleAudio: async function () {
      const speakerId = localStorage.getItem('speakerId');
      const microphoneId = localStorage.getItem('microphoneId');
      const availableSpeakerDevices = this.device.audio.availableOutputDevices;
      const speakers_size = availableSpeakerDevices.size;
      const availableInputpeakerDevices = await this.device.audio.availableInputDevices;
      const microphones_size = availableInputpeakerDevices.size;
      if (speakers_size === 0) {
        this.showErrorModal(this.notSetItem('スピーカー'));
        return false;
      }
      if (microphones_size === 0) {
        this.showErrorModal(this.notSetItem('マイク'));
        return false;
      }
      if (microphoneId) {
        await this.handleMicrophoneSelectionChange(microphoneId);
        try {
          await this.handleSpeakerSelectionChange(speakerId);
        } catch (e) {
          await this.handleSpeakerSelectionChange(DEFAULT_DEVICE);
        }
      }
      return true;
    },
    async handleMicrophoneSelectionChange(microphone) {
      localStorage.setItem('microphoneId', microphone);
      const availableInputpeakerDevices = this.device.audio.availableInputDevices;
      if (microphone !== null) {
        availableInputpeakerDevices.forEach(function (device) {
          if (device.deviceId === microphone) {
            localStorage.setItem('microphoneName', device.label.replace(/\(....:....\)/, ''));
          }
        });
      }
      if (this.device) {
        await this.device.audio.setInputDevice(microphone);
        if (!this.isConnectingCall && !this.isCalling) {
          try {
            if (this.device) await this.device.audio.unsetInputDevice();
          } catch (e) {
            console.info(e);
          }
        }
      }
    },
    async handleSpeakerSelectionChange(speaker) {
      localStorage.setItem('speakerId', speaker);
      const availableSpeakerDevices = this.device.audio.availableOutputDevices;
      if (speaker !== null) {
        availableSpeakerDevices.forEach(function (device) {
          if (device.deviceId === speaker) {
            localStorage.setItem('speakerName', device.label.replace(/\(....:....\)/, ''));
          }
        });
      }
      if (this.device) {
        await this.device.audio.speakerDevices.set(speaker);
        await this.device.audio.ringtoneDevices.set(speaker);
      }
    },
    /**
     * ステータス更新関連の関数
     * -------------------------------------------------------------
     */

    //アウトバウンド架電のステータス更新
    async handleUpdateCallStatus(updateData) {
      const result = await this.postRequest('/outbound/updateCallStatus', updateData)
        .then(e => {
          if (e.status === 'success') {
            return true;
          }
          return false;
        })
        .catch(e => {
          return false;
        });
      return result;
    },
    //通話中のステータスを更新（通話中：true)
    updateAgentCallingStatus(callingStatus) {
      this.postRequest('/clientUpdate', { callingStatus });
    },
    handleDisplayName() {
      if (!this.customerInfo.status) return '未選択';
      const currentStatus = this.callStatus.find(status => {
        return status.value === this.customerInfo.status;
      });
      if (currentStatus) return currentStatus.label;
      this.currentStatus = '';
      return '未選択';
    },
    /**
     * メモ関連の関数
     * -------------------------------------------------------------
     */
    handleGetMemo(callSid) {
      return this.postRequest('/callLogClient/getCallLogDetail', {
        callSid,
      })
        .then(e => {
          if (e.status === 'success' && e.data.length > 0) {
            return e.data[0].memo;
          }
          return '';
        })
        .catch(() => {
          return '';
        });
    },
    async handleSaveMemo(callSid, memo) {
      // memoがundefinedまたはnullだった場合は空文字に変換する
      const checkedMemo = memo === undefined || memo === null ? '' : memo;
      const saveMemoResult = await this.postRequest('/callLogClient/saveCallingMemo', {
        CallSid: callSid,
        Memo: checkedMemo.replace(/\n/g, '%%n%%'),
        isExtensionCallOutbound: false,
      })
        .then(e => {
          if (e.status === 'success') return e.data.updatedCallSid;
          return '';
        })
        .catch(() => {
          return '';
        });
      // Salesforce連携がONであればケースにメモを保存
      if (this.sfAvailable === true) {
        let pageUrlDomain = '';
        const pageUrlArr = window.location.href ? window.location.href.split('/') : [];
        if (pageUrlArr.length > 0) {
          pageUrlDomain = pageUrlArr[0] + '//' + pageUrlArr[2];
        } else {
          pageUrlDomain = '';
        }

        await this.postRequest('/callLogClient/updateSfCase', {
          CallSid: callSid,
          createdCaseId: this.customerInfo.createdCaseId,
          Memo: checkedMemo.replace(/\n/g, '%%n%%'),
          isExtensionCallOutbound: false,
          pageUrl: pageUrlDomain,
        }).catch(() => {
          //this.showErrorModal(messageContent.requireTry('SFメモを保存'));
          return '';
        });
      }
      return saveMemoResult;
    },

    /**
     * 保留関連の関数
     * -------------------------------------------------------------
     */
    handleHoldActionButtonClick() {
      window.addEventListener('beforeunload', this.handleUnlock);

      this.isHolding = !this.isHolding;
      if (this.isHolding) {
        this.handleHoldCall();
      } else {
        this.handleResumeCall();
      }
    },
    async handleHoldCall() {
      const callsid = this.customerInfo.currentCallSid;
      const self = this;
      this.customerInfo.status = 'onhold';
      this.isLoading = true;
      await this.postRequest('/hold', {
        CallSid: callsid,
        Direction: this.directionFlg,
        clientName: this.clientName,
        partnerClient: this.customerInfo.rawPhoneNumber,
      })
        .then(e => {
          if (e.status === 'success') {
            //発信元は切断したかチェック
            self.queueCheckInterval = setInterval(async function () {
              if (!self.customerInfo || self.customerInfo.status !== 'onhold') {
                clearInterval(self.queueCheckInterval);
              }
              const checkResult = await self.handleGetQueueInfo(callsid);
              if (!checkResult) {
                //エラーが発生、キューをチェックできない
                self.showErrorModal(messageContent.requireTry('保留'));
                clearInterval(self.queueCheckInterval);
              } else if (checkResult.currentMember === 0) {
                //発生元が切断した
                self.setCallEnd();
                clearInterval(self.queueCheckInterval);
              }
            }, 5000);
          } else if (e.status === statusConst.EXCEED_HOLD_COUNT_LIMIT) {
            self.customerInfo.status = 'active';
            self.isHoldCountExceeded = true;
            self.showErrorModal(messageContent.exceedHoldCountLimit);
          } else if (e.status === 'callIsHolding') {
            if (self.customerInfo) {
              self.customerInfo.status = 'active';
            }
            self.showErrorModal(messageContent.callIsHolding);
          } else if (e.status === 'updateCallFailed') {
            if (self.customerInfo) {
              self.isLoading = false;
              self.customerInfo.status = 'active';
            }

            self.showErrorModal(messageContent.notifyCalledDisconnected);
          } else {
            if (self.customerInfo) {
              self.customerInfo.status = 'active';
            }
            self.showErrorModal(messageContent.requireTry('保留'));
          }
          self.isLoading = false;
        })
        .catch(e => {
          self.isLoading = false;
          self.showErrorModal(messageContent.requireTry('保留'));
        });
    },
    async handleResumeCall() {
      this.isLoading = true;
      clearInterval(this.queueCheckInterval);
      const callsid = this.customerInfo.currentCallSid;
      const checkQueue = await this.handleGetQueueInfo(callsid);
      if (!checkQueue || checkQueue.currentMember === 0) {
        //保留中の発信元が切断
        this.setCallEnd();
        return;
      }

      const params = {
        To: callsid,
        From: this.formatSysTemCallNumber(this.currentPhoneNumber),
        Type: 'resume',
        DirectionFlg: this.directionFlg,
        CallerNumber: this.formatSysTemCallNumber(this.currentPhoneNumber),
        CustomerPhoneNumber: this.customerInfo.phoneNumber,
        CustomerRawPhoneNumber: this.customerInfo.rawPhoneNumber,
        CustomerTitle: this.customerInfo.title,
        companyID: this.companyID,
        userID: this.userID,
      };

      //発信桁数チェック(nullの場合は発信不可とする)
      if (params.To === null) {
        //console.log("宛先が空です。");
        return;
      }

      //console.log("Calling " + params.To + "...");
      if (this.device) {
        const outgoingConnection = await this.device.connect({ params });
        const self = this;

        outgoingConnection.on('accept', function (conn) {
          //保留を再開と新しいコールを作成したので、このコールのallSidをCookieに保存
          self.customerInfo.currentCallSid = conn.parameters.CallSid;
          self.handleAcceptIncomingCall(conn);
        });

        outgoingConnection.on('disconnect', function (conn) {
          self.handleDisconnectCall();
        });
      }
    },
    handleGetQueueInfo(callSid) {
      return this.postRequest('/hold/checkQueue', { callSid: callSid })
        .then(data => {
          if (data.status === 'success') return data.data;
          return null;
        })
        .catch(e => {
          return null;
        });
    },

    /**
     * SF関連の関数
     */

    // Salesforce連携設定の読み込み
    handleGetSettingSf() {
      this.postRequest('/callLogClient/getSfPopupAvailable', {})
        .then(e => {
          if (e.status === 'success') {
            this.sfAvailable = e.data.companyInfo.sfAvailable;
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('Salesforce連携設定の読み込み'));
        });
    },

    // 過去の通話履歴(ケース)を検索
    handleGetSfHistory() {
      this.postRequest('/callLogClient/getSfCases', { phoneNumber: this.customerInfo.phoneNumber })
        .then(e => {
          if (e.data) {
            this.customerInfo.sfCurrentInfo.sfCases = e.data.resultCases;
            for (const sfCase of this.customerInfo.sfCurrentInfo.sfCases) {
              const createdDateObj = new Date(sfCase.sfCreatedDate);
              const createdDateStr = createdDateObj.toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
              const createdTimeStr = createdDateObj.toLocaleTimeString('ja-JP', { timeZone: 'Asia/Tokyo' });
              sfCase.CreatedDateStr = createdDateStr + ' ' + createdTimeStr;
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('過去の通話履歴'));
        });
    },

    // Salesforce連絡先情報を検索
    handleGetSfContactInfo() {
      this.postRequest('/callLogClient/getSfContactInfo', {
        phoneNumber: this.customerInfo.phoneNumber,
      })
        .then(e => {
          if (e.data) {
            this.customerInfo.sfCurrentInfo.sfContactInfo = e.data.contactRecords;
          }
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry('連絡先情報を検索'));
        });
    },

    //SalesforcePopup
    handleGetSfPopup() {
      this.postRequest('/callLogClient/getSfPopupAvailable')
        .then(e => {
          if (e.status === 'success') {
            this.sfContactAvailable = e.data.companyInfo.sfContactAvailable;
            this.sfTable = e.data.companyInfo.sfTable;
            this.sfAvailable = e.data.companyInfo.sfAvailable;
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('SF設定情報'));
        });
    },
    handleCreateSf() {
      const currentCallInfo = {
        customerInfo: {
          phoneNumber: this.customerInfo.phoneNumber ? this.customerInfo.phoneNumber : '',
        },
      };

      let pageUrlDomain = '';
      const pageUrlArr = window.location.href ? window.location.href.split('/') : [];
      if (pageUrlArr.length > 0) {
        pageUrlDomain = pageUrlArr[0] + '//' + pageUrlArr[2];
      } else {
        pageUrlDomain = '';
      }

      return this.postRequest('/callLogClient/createSfCase', {
        CallSid: this.customerInfo.currentCallSid,
        callInfo: currentCallInfo,
        direction: this.directionFlg,
        isExtensionCallOutbound: true,
        pageUrl: pageUrlDomain,
        agentName: this.agentName,
        missedFlag: false,
      })
        .then(e => {
          if (e.status === 'success') {
            return e.data.createdCaseId;
          }
          return '';
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry('SF作成'));
          return '';
        });
    },
    checkIsValidCallSid(callSid) {
      if (!callSid) return false;

      return callSid.startsWith('CA');
    },
    caculateRemainMemoCount() {
      const currentMemoLength = this.customerInfo.memo ? this.customerInfo.memo.length : 0;
      return this.maxMemoLength - currentMemoLength;
    },
    loadMicrophoneList(devices) {
      if (!devices.length) return;
      const currentMicrophoneLocal = localStorage.getItem('microphoneId');
      this.microphoneListOptions = devices;
      for (const device of this.microphoneListOptions) {
        device.label = device.label.replace(/\(....:....\)/, '');
        if (device.value === currentMicrophoneLocal) this.currentMicrophone = currentMicrophoneLocal;
      }
    },
    loadSpeakerList(devices) {
      if (!devices.length) return;
      const currentSpeakerLocal = localStorage.getItem('speakerId');
      this.speakerListOptions = devices;
      for (const device of this.speakerListOptions) {
        device.label = device.label.replace(/\(....:....\)/, '');
        if (device.value === currentSpeakerLocal) this.currentSpeaker = currentSpeakerLocal;
      }
    },
    handlerFetchSettingOther: async function () {
      const self = this;
      await this.postRequest('/settingother')
        .then(data => {
          if (data.status === 'success') {
            if (data.data) {
              self.COTOHACallCenterManualURL = data.data.COTOHACallCenterManualURL
                ? data.data.COTOHACallCenterManualURL
                : '';
            }
          } else {
            self.showErrorModal(messageContent.requireTry('設定の取得'));
          }
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('設定の取得'));
        });
    },
    handleCloseCancelCallErrorModalTitle: function () {
      this.cancelCallErrorModalVisible = false;
      this.$router.go(0);
    },
    showCancelCallErrorModal: function () {
      this.cancelCallErrorModalVisible = true;
    },
    delay: function (time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
  },
};
</script>
